exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content.has-buttons[data-v-3a2f7c3e] {\n  margin-right: 92px;\n}\n.content[data-v-3a2f7c3e] {\n  width: 100%;\n  min-width: 0;\n  max-width: 100% !important;\n  height: 100%;\n  overflow-x: clip;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.header-wrapper[data-v-3a2f7c3e] {\n  background-color: white;\n  padding-top: 30px;\n}\n.customer-page[data-v-3a2f7c3e] {\n  display: flex;\n  position: relative;\n  gap: 16px;\n  background-color: #e9f1fb;\n  height: 100%;\n}\n.customer-page .action-buttons[data-v-3a2f7c3e] {\n  flex-grow: 0;\n  flex-shrink: 1;\n}", ""]);

// exports
